import { render } from "./myPage.vue?vue&type=template&id=33e8dfd8&scoped=true&ts=true"
import script from "./myPage.vue?vue&type=script&lang=ts"
export * from "./myPage.vue?vue&type=script&lang=ts"

import "./myPage.vue?vue&type=style&index=0&id=33e8dfd8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/A-生产-h5-prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e8dfd8"]])

export default __exports__